import { render } from "./TeamMenu.vue?vue&type=template&id=bda2d318"
import script from "./TeamMenu.vue?vue&type=script&lang=js"
export * from "./TeamMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__